import { render, staticRenderFns } from "./LocationNotifications.vue?vue&type=template&id=f3ad971c&"
import script from "./LocationNotifications.vue?vue&type=script&lang=js&"
export * from "./LocationNotifications.vue?vue&type=script&lang=js&"
import style0 from "./LocationNotifications.vue?vue&type=style&index=0&id=f3ad971c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports